<form-section [subtitle]="subtitle(8054)" data-testid="module-options">
    @if (!settings.isZonesSingleController()) {
        <form-card-button [subtitle]="subtitle(13914)"
                          (onClick)="settingsSave.makePdf(this.settings.selectedModule)">
        </form-card-button>
    }
    <form-card-button [subtitle]="subtitle(734)"
                      (onClick)="sendPw()">
    </form-card-button>
    <form-card-button [subtitle]="subtitle(2877)"
                      [danger]="true"
                      (onClick)="deleteModule(settings.selectedModule)">
    </form-card-button>
</form-section>

@if (settingsSave.showInput) {
    <app-dialog [subtitle]="subtitle(13914)" (close)="closeDialog()">
        <pin-form></pin-form>
    </app-dialog>
}
